function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCreditCardIcons = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 0,
  height: 0,
  className: "hidden"
}, props));
export { SvgCreditCardIcons as ReactComponent };
export default __webpack_public_path__ + "assets/media/credit-card-icons.1f452ec4a877efcb843ff76421bb2a1f.svg";